import { useState, useCallback } from "react";

export function useAppointmentFilters() {
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [professionalId, setProfessionalId] = useState("");
  const [status, setStatus] = useState("");

  const params = useCallback(() => {
    const p = {};
    if (dateFrom) p.dateFrom = dateFrom;
    if (dateTo) p.dateTo = dateTo;
    if (professionalId) p.professionalId = professionalId;
    if (status) p.status = status;
    return p;
  }, [dateFrom, dateTo, professionalId, status]);

  const reset = useCallback(() => {
    setDateFrom("");
    setDateTo("");
    setProfessionalId("");
    setStatus("");
  }, []);

  return { dateFrom, setDateFrom, dateTo, setDateTo, professionalId, setProfessionalId, status, setStatus, params, reset };
}
